import l from "react";
import { ToolbarButton as T } from "./index322.mjs";
import { CONTROLS as s } from "./index323.mjs";
import h from "./index324.mjs";
var x = Object.defineProperty, c = Object.getOwnPropertySymbols, f = Object.prototype.hasOwnProperty, m = Object.prototype.propertyIsEnumerable, i = (e, r, t) => r in e ? x(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, I = (e, r) => {
  for (var t in r || (r = {}))
    f.call(r, t) && i(e, t, r[t]);
  if (c)
    for (var t of c(r))
      m.call(r, t) && i(e, t, r[t]);
  return e;
}, R = (e, r) => {
  var t = {};
  for (var a in e)
    f.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && c)
    for (var a of c(e))
      r.indexOf(a) < 0 && m.call(e, a) && (t[a] = e[a]);
  return t;
};
function S(e) {
  var r = e, {
    controls: t,
    labels: a,
    stickyOffset: p = 0,
    sticky: v = !0,
    className: y,
    classNames: u,
    styles: _,
    id: d,
    unstyled: O
  } = r, b = R(r, [
    "controls",
    "labels",
    "stickyOffset",
    "sticky",
    "className",
    "classNames",
    "styles",
    "id",
    "unstyled"
  ]);
  const { classes: n, cx: N } = h({ sticky: v, stickyOffset: p }, { classNames: u, styles: _, unstyled: O, name: "RichTextEditor" }), E = t.map((P, g) => {
    const k = P.filter((o) => s[o]).map((o) => {
      const w = s[o].icon;
      return /* @__PURE__ */ l.createElement(T, {
        className: n.toolbarControl,
        controls: s[o].controls,
        value: s[o].value,
        key: o,
        title: a[o],
        noActive: s[o].noActive
      }, /* @__PURE__ */ l.createElement(w, {
        size: 18,
        stroke: 1.5
      }));
    });
    return /* @__PURE__ */ l.createElement("div", {
      className: n.toolbarGroup,
      key: g
    }, k);
  });
  return /* @__PURE__ */ l.createElement("div", I({
    id: d,
    className: N(n.toolbar, y)
  }, b), /* @__PURE__ */ l.createElement("div", {
    className: n.toolbarInner
  }, E));
}
S.displayName = "@mantine/rte/Toolbar";
export {
  S as Toolbar
};
